<template>
  <div class="container about pt-5">
    <div class="row aboutPage">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-6 content-center">
            <h4 class="mb-3">{{$t('about.title')}}</h4>
            <h4 class="companyTitle">{{$t("about.companyName")}}</h4>
            <p class="small-Font pt-2">{{$t('about.text_1')}}</p>
            <p class="accreditations">{{$t('about.text_2')}}</p>
          </div>
          <div class="col-12 col-md-6">
            <img src="/assets/images/image.png" class="w-100 br-radius-24" alt="">
          </div>
        </div>


        <div class="row pt-3">
          <div class="col">
            <div class="card vision">
              <div class="card-body p-1">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="card">
                      <div class="card-body content_About">
                        <div class="py-2">
                          <img src="/assets/images/icons/featured-Icon.png" class="max-48" alt="">
                        </div>
                        <h4>{{$t('about.vision')}}</h4>
                        <p class="small-Font pt-2">{{$t('about.vision_p')}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 message">
                    <div class="card">
                      <div class="card-body content_About">
                        <div class="py-2">
                          <img src="/assets/images/icons/featuredMessage.png" class="max-48" alt="">
                        </div>
                        <h4>{{$t('about.message')}} </h4>
                        <p class="small-Font pt-2">{{$t('about.message_p')}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-5">
          <div class="col">
            <div>{{$t('about.fieldsWork')}}</div>
            <div class="fieldsWork">
              <div>{{$t('about.comprehensive')}}</div>
              <div>{{$t('about.comprehensive_P')}}</div>
            </div>
          </div>
        </div>
        <div class="row scroll-row pt-3">
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-1.png" class="img-fluid" alt="">
                <div>{{$t('about.propertyManagement')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-2.png" class="img-fluid" alt="">
                <div>{{$t('about.realEstate_marketing')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-3.png" class="img-fluid" alt="">
                <div>{{$t('about.ownersAssociation')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-4.png" class="img-fluid" alt="">
                <div>{{$t('about.digitalMarketing')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-5.png" class="img-fluid" alt="">
                <div>{{$t('about.realEstate_Auctions')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-6.png" class="img-fluid" alt="">
                <div>{{$t('about.realEstate_Appraisal')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-7.png" class="img-fluid" alt="">
                <div>{{$t('about.off_plan_sales')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-8.png" class="img-fluid" alt="">
                <div>{{$t('about.realEstate_financing')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-9.png" class="img-fluid" alt="">
                <div>{{$t('about.legalServices')}}</div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 majalatAleamal">
            <div class="card">
              <div class="card-body">
                <img src="/assets/images/Image-10.png" class="img-fluid" alt="">
                <div>{{$t('about.maintenance')}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col">
            <div class="scroll-wrapper">
              <button class="scroll-btn left" @click="scrollLeft">
                ‹
              </button>

              <div ref="scrollContainer" class="scroll-container">
                <div class="row">
                  <div class="col-12 col-md-4 majalatAleamal" >
                    <div class="card">
                      <div class="card-body">
                        <div v-for="item in photo" :key="item.id" class="scroll-item">
                          <img :src="MEDIA_URL+item" class="img-fluid" alt="">
                        </div>
                        <div>{{$t('about.propertyManagement')}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button class="scroll-btn right" @click="scrollRight">
                ›
              </button>
            </div>

            <div class="scroll-dots">
              <span
                v-for="(_, index) in dots"
                :key="index"
                :class="{ active: currentDot === index }"
                @click="goToDot(index)"
              ></span>
            </div>
          </div>
        </div> -->

        <div class="row pt-5">
          <div class="col-12 text-center">
            <img src="/assets/images/photo-band.png" class="w-100" alt="">
          </div>
        </div>

        <div class="row py-5">
          <div class="col">
            <h6>{{$t('about.featuresGroup')}}</h6>
            <h3 class="methodo">{{$t('about.methodologyAttention')}}</h3>
            <div class="row pt-3">
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-1.png" class="max-48" alt="">
                    <div>{{$t('about.distinguishedTeam')}}</div>
                    <p>{{$t('about.qualifiedRealEstate')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-2.png" class="max-48" alt="">
                    <div>{{$t('about.integrationGovernment')}}</div>
                    <p>{{$t('about.directTechnical')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-3.png" class="max-48" alt="">
                    <div>{{$t('about.modernTechnology')}}</div>
                    <p>{{$t('about.innovativeTechnologies')}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-2">
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-4.png" class="max-48" alt="">
                    <div>{{$t('about.necessaryLicenses')}}</div>
                    <p>{{$t('about.licensedRegistered')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-5.png" class="max-48" alt="">
                    <div>{{$t('about.bestSystems')}}</div>
                    <p>{{$t('about.advancedCloud_based')}}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 featuresGroup">
                <div class="card">
                  <div class="card-body">
                    <img src="/assets/images/icons/icon-container-6.png" class="max-48" alt="">
                    <div>{{$t('about.customer_Callcenter')}}</div>
                    <p>{{$t('about.comprehensiveSupport')}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-4 d-none d-lg-block">
          <div class="col-12 section">
            <div>{{$t('about.interested')}}</div>
            <div class="manageProperty">{{$t('about.manageProperty')}}</div>
            <p>{{$t('about.dedicatedCustomer')}}</p>
            <div class="row">
              <div class="col contactInformation">
                <div>
                  <span>{{$t('about.phone_WhatsApp')}} :</span>
                  <span class="mx-2 almarai-bold">{{$t('about.phoneNumber')}}</span>
                </div>
                <div>
                  <span>{{$t('about.email')}} :</span>
                  <span class="mx-2 almarai-bold">info@amaqaria.com</span>
                </div>
                <div>
                  <span>{{$t('about.address')}} :</span>
                  <span class="mx-2 almarai-bold">{{$t('about.location')}}</span>
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-auto contactNow">
                <a class="text-white" href="https://wa.me/+966920016962?text= السلام عليكم أود التواصل مع أخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى. شكرًا لكم"  target="_blank">
                  {{$t('about.contactNow')}}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-block d-lg-none">
          <div class="col-12">
            <div class="card bg-footer-black">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="interested">{{$t('about.interested')}}</div>
                    <div class="manageProperty">{{$t('about.manageProperty')}}</div>
                    <p class="manageProperty_content">{{$t('about.dedicatedCustomer')}}</p>
                  </div>
                  <hr>
                  <div class="col-12 contactInformation">
                    <div>
                      <span>{{$t('about.phone_WhatsApp')}} :</span>
                      <span class="mx-2 almarai-bold">{{$t('about.phoneNumber')}}</span>
                    </div>
                    <div class="email">
                      <span>{{$t('about.email')}} :</span>
                      <span class="mx-2 almarai-bold">info@amaqaria.com</span>
                    </div>
                    <div>
                      <span>{{$t('about.address')}} :</span>
                      <span class="mx-2 almarai-bold">{{$t('about.location')}}</span>
                    </div>
                    <div class="row pt-3">
                      <div class="col-auto contactNow">
                        <a class="text-white" href="https://wa.me/+966920016962?text= السلام عليكم أود التواصل مع أخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى. شكرًا لكم"  target="_blank">
                          {{$t('about.contactNow')}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col">
            <h4>{{$t('about.text_32')}}</h4>
            <ul class="small-Font">
              <li>
                <span>{{$t('about.text_33')}}</span>
                <ol>
                  <li class="py-2">{{$t('about.text_34')}}</li>
                  <li>{{$t('about.text_35')}}</li>
                  <li class="py-2">{{$t('about.text_36')}}</li>
                  <li>{{$t('about.text_37')}}</li>
                  <li class="py-2">{{$t('about.text_38')}}</li>
                </ol>
              </li>
            </ul>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col">
            <h4>{{$t("about.text_39")}}</h4>
            <ul class="small-Font">
              <li>
                <p class="m-0 pt-2">{{$t('about.text_40')}}</p>
                <ol>
                  <li class="py-2">{{$t('about.text_41')}}</li>
                  <li>{{$t('about.text_42')}}</li>
                  <li class="py-2">{{$t('about.text_43')}}</li>
                  <li>{{$t('about.text_44')}}</li>
                  <li class="py-2">{{$t('about.text_45')}}</li>
                </ol>
              </li>
            </ul>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-10">
            <h4>{{$t('about.text_46')}} </h4>
            <p>{{$t('about.text_47')}}</p>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col">
            <h4>{{$t('about.text_48')}}</h4>
            <ul class="small-Font">
              <li>{{$t('about.text_49')}}</li>
              <li class="py-2">⁠{{$t('about.text_50')}}</li>
              <li>{{$t('about.text_51')}}</li>
              <li class="py-2">{{$t('about.text_52')}}</li>
              <li>{{$t('about.text_53')}}</li>
              <li>{{$t('about.text_54')}}</li>
            </ul>
          </div>
        </div> -->

        <!-- <div class="row pt-3">
          <div class="col fonttext-14">
            <h4 class="py-2">{{$t('about.text_55')}}</h4>
            <div class="pb-2">
              <span>{{$t('about.text_56')}}</span> 
              <span class="orange-color almarai-bold mx-2">920016962</span>
            </div>
            <div class="pb-2">
              <span>{{$t('about.text_57')}}</span>
              <span class="orange-color almarai-bold mx-2">info@amaqaria.com</span>
            </div>

            <div class="row">
              <div class="col-auto">
                <span>{{$t('about.text_58')}}</span>
              </div>
              <div class="col p-0">
                <span class="orange-color almarai-bold">
                  {{$t('about.address')}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center aboutUs socialMediaFooter pt-5">
          <div class="col-auto">
            <a href="https://www.tiktok.com/@amaqaria" target="_blank">
              <img class="tiktok-A" src="/assets/images/icons/tiktok-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://www.snapchat.com/add/almuhaysini_sa" target="_blank">
              <img class="snapchat-A" src="/assets/images/icons/Snapchat-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://www.youtube.com/@amaqaria" target="_blank">
              <img class="youtube-A" src="/assets/images/icons/Youtube-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://x.com/amaqaria" target="_blank">
              <img class="twitter-A" src="/assets/images/icons/twiter-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://www.instagram.com/amaqaria" target="_blank">
              <img class="instagram-A" src="/assets/images/icons/instagram-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://www.facebook.com/Amaqaria" target="_blank">
              <img class="facebook-A" src="/assets/images/icons/facebook-w.png"  alt="">
            </a>
          </div>
          <div class="col-auto">
            <a href="https://www.linkedin.com/company/%D9%85%D8%AC%D9%85%D9%88%D8%B9%D8%A9-%D8%A3%D8%AD%D9%85%D8%AF-%D8%A7%D9%84%D9%85%D8%AD%D9%8A%D8%B3%D9%86%D9%8A-%D8%A7%D9%84%D8%B9%D9%82%D8%A7%D8%B1%D9%8A%D8%A9/?viewAsMember=true" target="_blank">
              <img class="linkedin-A" src="/assets/images/icons/linkedin-w.png"  alt="">
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { mapGetters } from 'vuex';
const scrollContainer = ref(null);
const dots = [0, 1, 2, 3];
export default {
  name: 'aboutus',
  data(){
    return {
      isActive: false,
      photo: [
        "assets/images/Image-1.png",
        "assets/images/Image-2.png",
        "assets/images/Image-3.png",
        "assets/images/Image-4.png",
        "assets/images/Image-5.png",
        "assets/images/Image-6.png",
        "assets/images/Image-7.png",
        "assets/images/Image-8.png",
        "assets/images/Image-9.png",
        "assets/images/Image-10.png",
      ]
      
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER'])
  },
  methods: {
    goToDot (index){
      currentDot.value = index;
      scrollContainer.value.scrollTo({
        left: index * 250,
        behavior: "smooth"
      });
    },

    scrollLeft(){
      scrollContainer.value.scrollBy({
        left: -250,
        behavior: "smooth"
      });

      if (currentDot.value > 0) {
        currentDot.value--;
      }
    },

    scrollRight() {
      scrollContainer.value.scrollBy({
        left: 250,
        behavior: "smooth"
      });

      if (currentDot.value < dots.length - 1) {
        currentDot.value++;
      }
    },
  },

  created(){
    // if(window.getComputedStyle(document.getElementById("mobNavBtn"),null).getPropertyValue('display') == 'block' && window.getComputedStyle(document.getElementById("navbarNavDropdown"),null).getPropertyValue('display') == 'block'){
    //   document.getElementById("mobNavBtn").click();
    // }
  }
}
</script>
<style scoped>
.scroll-wrapper {
  position: relative;
}

.scroll-container {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-item {
  min-width: 220px;
}

/* Buttons */
.scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;

  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;

  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 30px;
  line-height: 30px;
}

.scroll-btn.left {
  left: 10px;
}

.scroll-btn.right {
  right: 10px;
}

/* White dots */
.scroll-dots {
  display: flex;
  justify-content: center;
  gap: 7px;
  margin-top: 10px;
}

.scroll-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
  opacity: 0.5;
  cursor: pointer;
}

.scroll-dots span.active {
  opacity: 1;
  width: 22px;
  border-radius: 10px;
}
</style>